import React, { useState } from 'react';
import './EventSchedule.css';

const scheduleData = {
    "Main Stage": [
        { id: 1, name: "Thiruvathira", time: "8:00am - 8:40am" },
        { id: 2, name: "MargamKali", time: "8:45am - 8:55am" },
        { id: 3, name: "Mime", time: "9:00am - 9:15am" },
        { id: 4, name: "Scene Recreation", time: "9:20am - 9:40am" },
        { id: 5, name: "Group Dance Semi-Classical", time: "9:40am - 10:00am" },
        { id: 6, name: "Inaguration", time: "10:00am - 11:00am" },
        { id: 7, name: "Music Band", time: "11:00am - 11:40am" },
        { id: 8, name: "Individual Dance Semi-Classical", time: "11:45am - 12:15pm" },
        { id: 9, name: "Duo Dance Semi-Classical", time: "12:20pm - 1:10pm" },
        { id: 10, name: "Group Dance Western", time: "1:15pm - 1:55pm" },
        { id: 11, name: "Skit", time: "2:00pm - 2:10pm" },
        { id: 12, name: "Fashion Show", time: "2:15pm - 3:15pm" }
    ],
    "Auditorium": [
        { id: 1, name: "Individual Dance Classical", time: "9:00am - 9:30am" },
        { id: 2, name: "Folk Dance", time: "9:35am - 9:55am" },
        { id: 3, name: "Individual Dance Western", time: "11:00am - 11:25am" },
        { id: 4, name: "Synchro", time: "11:30am - 11:55am" },
        { id: 5, name: "Fancy Dress", time: "12:00pm - 12:10pm" },
        { id: 6, name: "Spot Choreo", time: "12:15pm - 12:40pm" },
        { id: 7, name: "Duff Muttu", time: "12:45pm - 12:55pm" },
        { id: 8, name: "Duo Dance Western", time: "1:00pm - 1:30pm" }
    ],
    "Seminar Hall": [
        { id: 1, name: "Group Song", time: "9:00am - 9:45am" },
        { id: 2, name: "Stand-Up Comedy", time: "9:45am - 10:00am" },
        { id: 3, name: "Solo Song Western", time: "11:00am - 11:30am" },
        { id: 4, name: "Mono Act", time: "11:35am - 11:50am" },
        { id: 5, name: "Mappilapattu", time: "11:55am - 12:25pm" },
        { id: 6, name: "Duet", time: "12:30pm - 1:05pm" },
        { id: 7, name: "Solo Song Classical", time: "1:10pm - 1:35pm" },
        { id: 8, name: "Nadan Pattu", time: "1:40pm - 2:10pm" },
        { id: 9, name: "Instrumental music", time: "2:15pm - 2:45pm" }
    ]
};

const EventSchedule = () => {
    const [activeVenue, setActiveVenue] = useState("Main Stage");

    return (
        <section className="event-schedule-section" id="event-schedule">
            <h2 className="section-title">EVENT SCHEDULE</h2>

            <div className="venue-tabs">
                {Object.keys(scheduleData).map(venue => (
                    <button
                        key={venue}
                        className={`venue-tab ${activeVenue === venue ? 'active' : ''}`}
                        onClick={() => setActiveVenue(venue)}
                    >
                        {venue}
                    </button>
                ))}
            </div>

            <div className="schedule-container">
                <div className="schedule-header">
                    <div className="col-no">#</div>
                    <div className="col-event">EVENT NAME</div>
                    <div className="col-time">TIME SLOT</div>
                </div>
                <div className="schedule-list">
                    {scheduleData[activeVenue].map((event) => (
                        <div key={event.id} className="schedule-row">
                            <div className="col-no">{event.id}</div>
                            <div className="col-event">{event.name}</div>
                            <div className="col-time">{event.time}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EventSchedule;
